import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Sidebar } from './models/sidebar.model';
import { SidebarService } from './services/sidebar.service';

@Component({
  selector: 'app-sb-editor-sidebar',
  templateUrl: './sb-editor-sidebar.component.html',
  styleUrls: ['./sb-editor-sidebar.component.scss'],
})
export class SbEditorSidebarComponent implements OnInit, OnDestroy {
  public sidebar: Sidebar;
  private subscriptions: Array<Subscription>;
  public toolImg: string;

  constructor(private sidebarService: SidebarService) {
    this.subscriptions = [];
    this.sidebar = {
      active: 'colors',
      text: 'Plantillas web',
      grid: { hidden: false, extended: false },
      // active: 'header' , text: "Cabecera", grid: {hidden: false, extended: false}
    };
    //this.sidebar = { active: 'availability' , text: "Disponibilidad"};
    this.toolImg = '/assets/img/tools/header.svg';
  }

  ngOnInit(): void {
    this.sidebarService.setAsyncSidebar(this.sidebar);

    let sidebar$ = this.sidebarService.getSidebar$().subscribe(res => {
      this.sidebar = res;
      if (this.sidebar.active) {
        this.toolImg = '/assets/img/tools/' + this.sidebar.active + '.svg';
      }
    });
    this.subscriptions.push(sidebar$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public sidebarExpandToggle() {
    // toggle
    this.sidebar.grid.hidden = false;
    this.sidebar.grid.extended = !this.sidebar.grid.extended;
    this.sidebarService.setSidebar(this.sidebar);
  }

  public listenChildren() {}
}
